<script setup lang="ts">
defineProps<{
	progress: number;
}>();
</script>

<template>
	<div class="relative flex min-h-64 w-full items-center">
		<DSkeleton class="absolute inset-0 rounded-none bg-elevated/50" />
		<Transition appear appear-active-class="transition-opacity duration-1075 delay-1000" appear-to-class="opacity-100" appear-from-class="opacity-0">
			<div class="flex size-full flex-col items-center justify-center gap-2">
				<DIcon class="animate-spin" name="lucide:loader-circle" size="24" />
				<p class="text-xs font-medium tabular-nums">
					{{ (progress * 100).toFixed() }}%
				</p>
			</div>
		</Transition>
	</div>
</template>
